import { HelpCircle } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../ui/popover';
import { usePortalHelp } from '../../context/PortalHelpContext';
import { getSectionHelp } from '../../config/portalPageHelp';
import { useLocation } from 'react-router-dom';

export default function HelpSectionHint({ sectionId, className = '' }) {
  const location = useLocation();
  const { openHelp, scrollToSection } = usePortalHelp();
  const section = getSectionHelp(location.pathname, location.search, sectionId);

  if (!section) return null;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={`h-7 w-7 rounded-full text-text-muted hover:text-primary hover:bg-primary/10 ${className}`}
          aria-label={`Help: ${section.title}`}
          onClick={(e) => e.stopPropagation()}
        >
          <HelpCircle className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-[min(340px,calc(100vw-2rem))] p-0 overflow-hidden border-[#E4E8EB] shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-primary/5 px-4 py-3 border-b border-[#E4E8EB]">
          <p className="text-sm font-semibold text-text-primary">{section.title}</p>
        </div>
        <div className="px-4 py-3 space-y-3 text-sm text-text-muted">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-wide text-primary mb-1">What is this?</p>
            <p className="leading-relaxed">{section.what}</p>
          </div>
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-wide text-primary mb-1">What to do</p>
            <p className="leading-relaxed">{section.doThis}</p>
          </div>
          {section.mistakes ? (
            <div className="rounded-lg bg-amber-50 border border-amber-100 px-3 py-2">
              <p className="text-[11px] font-semibold uppercase tracking-wide text-amber-800 mb-1">Common mistake</p>
              <p className="text-amber-900/90 leading-relaxed">{section.mistakes}</p>
            </div>
          ) : null}
        </div>
        <div className="px-4 py-2 border-t border-[#E4E8EB] bg-[#F8FAFA] flex gap-2">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="text-xs h-8"
            onClick={() => scrollToSection(sectionId)}
          >
            Show on page
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="text-xs h-8"
            onClick={() => openHelp({ tab: 'sections', sectionId })}
          >
            More help
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}